import { useEffect, useMemo, useState } from "react";

export default function useScrollDirection(
  settings: { scrollContainer?: HTMLElement; threshold?: number } = {
    scrollContainer: document.body,
    threshold: 0,
  },
) {
  const [scrollDirection, setScrollDirection] = useState<"down" | "up" | null>(
    null,
  );
  const container = useMemo(
    () => settings.scrollContainer ?? document.body,
    [settings.scrollContainer],
  );
  const threshold = useMemo(
    () => settings.threshold ?? 0,
    [settings.threshold],
  );

  useEffect(() => {
    let lastScrollY = container.scrollTop;

    const updateScrollDirection = () => {
      const scrollY = container.scrollTop;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > threshold ||
          scrollY - lastScrollY < -threshold)
      ) {
        setScrollDirection(direction);
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    container.addEventListener("scroll", updateScrollDirection);

    return () => {
      container.removeEventListener("scroll", updateScrollDirection);
    };
  }, [container, scrollDirection, threshold]);

  return scrollDirection;
}
